<template>
  <div>
  <b-row class="supporter-row" v-for="(i,idx) in Math.ceil(supporters.length / 5)" :key="idx">
    <b-col cols="12" sm="6" lg="2" id="f1_container" v-for="(item, index) in supporters.slice((i - 1) * 5, i * 5)" :key="index">
    <div id="f1_card" class="shadow">
        <div class="front face" :style="{ 'background-image': 'url(' + imagePath(item.imageLink) + ')' }">
        </div>
      <a :href="item.externalLink" target="_blank">
        <div class="back face center">
          <div class="back-text">
          <h2>{{item.name}}</h2>
          <h4>{{item.description}}</h4>
          </div>
        </div>
      </a>
      </div>
    </b-col>
  </b-row>
  </div>
</template>

<script>
    export default {
      name: 'MainSupporters',
      data () {
        return {
          supporters: []
        }
      },
      methods: {
        imagePath (imageName) {
          return require('../../../assets/main_supporters/' + imageName)
        },
        loadMainSupporters () {
          let self = this
          this.$http.get(this.$PATH_NAME + 'partners/main/').then(response => {
            if (response.status === 200) {
              self.supporters = response.body
            }
          }).catch(function (err) {
            this.handleError(err)
          })
        },
        handleError (err) {
          if (err.status >= 500) {
            console.log('Server-Related problem')
          } else if (err.status === 400) {
            console.log('A bad request occurred')
          } else if (err.status === 404) {
            console.log(err.body.message)
          }
        }
      },
      mounted () {
        this.loadMainSupporters()
      }
    }
</script>

<style scoped>
  #f1_container {
    position: relative;
    margin: 10px auto;
    width: 22em;
    height: 13em;
    z-index: 1;
    cursor: pointer;
  }
  #f1_container {
    perspective: 1000;
  }
  #f1_card {
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: all 0.5s linear;
  }
  #f1_container:hover #f1_card {
    transform: rotateY(180deg);
    box-shadow: 10px 10px 8px #aaa;
  }
  .face {
    position: absolute;
    width: 85%;
    height: 100%;
    backface-visibility: hidden;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  .face.back {
    display: block;
    transform: rotateY(180deg);
    box-sizing: border-box;
    padding: 10px;
    color: white;
    text-align: center;
    background-color: #c41c21;
    width: 100%;
    height: 100%;
  }
  .back-text {
    margin-top: 2em;
  }

  .supporter-row {
    margin: 2em;
  }

  h2 {
    font-size: 1.3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/supportersPageComponents/MainSupporters.vue